<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 18 18"
  enable-background="new 0 0 18 18"
  xml:space="preserve"
>
  <rect x="3" y="13" fill="currentColor" width="13" height="2" />
  <rect x="3" y="8" fill="currentColor" width="13" height="2" />
  <rect x="3" y="3" fill="currentColor" width="13" height="2" />
</svg>
